import { IPayloadAccionesDTO, PayloadAccionesDTO } from "./PayloadAcciones.DTO";
import { obtenerIdTipoAccion, TipoAccionesEnum } from "@shared/enums";
import { Nilable } from "@shared/utils";

export interface IAccionesItemDTO {
    id: number;
    type: string;
    payload: IPayloadAccionesDTO;
    item: number;
}

export class AccionesItemDTO {
    public id = 0;
    public type: TipoAccionesEnum = TipoAccionesEnum.ADD_TAG_TO_USER;
    public payload = new PayloadAccionesDTO();
    public item = 0;

    constructor(json: Nilable<Partial<IAccionesItemDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IAccionesItemDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.type != null) {
            this.type = TipoAccionesEnum[json.type];
        }
        this.payload = new PayloadAccionesDTO(json.payload);
        if (json.item != null) {
            this.item = json.item;
        }
    }

    public toJSON(): IAccionesItemDTO {
        return {
            id: this.id,
            type: obtenerIdTipoAccion(this.type),
            payload: this.payload.toJSON(),
            item: this.item
        };
    }
}
